import { useId, type InputHTMLAttributes } from 'react'
import FieldHelp from './FieldHelp'

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label: string
  hint?: string
  /** Erklärung hinter einem Fragezeichen am Label. */
  help?: string
  error?: string
}

export default function TextField({ label, hint, help, error, className = '', ...rest }: Props) {
  const id = useId()
  const describedBy = error ? `${id}-error` : hint ? `${id}-hint` : undefined

  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between gap-2">
        <label htmlFor={id} className="block text-sm font-medium">
          {label}
        </label>
        {help && <FieldHelp text={help} />}
      </div>
      <input
        {...rest}
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        className={`border-crema-300 dark:border-roast-600 dark:bg-roast-800/60 focus:border-roast-500 focus:ring-roast-500/30 w-full rounded-lg border bg-white/80 px-3 py-2 text-sm focus:ring-2 focus:outline-none ${error ? 'border-over' : ''} ${className}`}
      />
      {error ? (
        <p id={`${id}-error`} className="text-over text-xs">
          {error}
        </p>
      ) : hint ? (
        <p id={`${id}-hint`} className="text-roast-500 dark:text-crema-300/70 text-xs">
          {hint}
        </p>
      ) : null}
    </div>
  )
}
